import { IconBuildingFactory2 } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../mantine/mrt/components/cell/MantineIconCell";
import type { Person } from "../../../../../utils/backend-types";
import type { Contract } from "../../../DeliveryOverview.types";

export function getSuppliedColumn(
  contracts: Array<Contract>,
  persons: Array<Person>
): MRT_ColumnDef<Contract> {
  const usedSuppliedIds = contracts.map((contract) => contract.supplied);
  const sortedUsedSupplieds = persons
    .filter((person) => usedSuppliedIds.includes(person.id))
    .map((person) => person.name)
    .sort((personA, personB) => personA.localeCompare(personB));
  const usedSuppliedsSet = Array.from<string>(new Set(sortedUsedSupplieds));
  const uniqueUsedSupplies = Array.from(usedSuppliedsSet);

  return {
    accessorKey: "supplied",
    accessorFn: (row) => {
      return persons.find((person) => person.id === row.supplied)?.name || "";
    },
    header: "Belieferter",
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedSupplies
    },
    Cell: (props) => (
      <MantineIconCell {...props} IconComponent={IconBuildingFactory2} />
    )
  };
}
